import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import {
  handelConvertDataTagById,
  handleDataProvince,
  handleDataProvinceImport,
  handleSelectCheckBox,
} from '../filterSetting/helper'
import { getProvinceVietNamese } from './thunk'

const initialState = {
  dataProvince: [],
  dataProvinceImport: [],
  listSelectedProvince: [],
  textSearch: '',
  loading: false,
}

const slice = createSlice({
  name: 'common/filterCompany/province',
  initialState,
  reducers: {
    changeListSelectedProvince: (state, action) => {
      state.listSelectedProvince = handleSelectCheckBox(
        state.listSelectedProvince,
        action.payload,
      )
    },
    changeTextSearchProvince: (state, action) => {
      state.textSearch = action.payload
    },
    covertDataProvinceById: (state, action) => {
      state.listSelectedProvince = handelConvertDataTagById(
        action.payload,
        state.dataProvinceImport,
      )
    },
    resetStoreProvince: (state) => {
      Object.keys(initialState).forEach((key) => {
        if (key === 'dataProvince') return null
        state[key] = initialState[key]
      })
    },
  },
  extraReducers: (builder) => {
    //Province
    builder.addCase(getProvinceVietNamese.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getProvinceVietNamese.fulfilled, (state, action) => {
      state.dataProvince = handleDataProvince(action.payload)
      state.dataProvinceImport = handleDataProvinceImport(action.payload)
      state.loading = false
    })
    builder.addCase(getProvinceVietNamese.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
  },
})

export const loadingProvince = (state) => state[slice.name].loading
export const selectDataProvince = (state) => state[slice.name].dataProvince

export const selectListSelectedProvince = (state) =>
  state[slice.name].listSelectedProvince

export const selectTextSearchProvince = (state) => state[slice.name].textSearch

export const {
  resetStoreProvince,
  changeListSelectedProvince,
  changeTextSearchProvince,
  covertDataProvinceById,
} = slice.actions

register(slice.name, slice.reducer)
